import { Link } from 'react-router-dom';


const Home = () => {
    return <>

        <section className="sec-ii">
            <div className="container">
                <div className="main-heading text-center">
                    <h1 className="main-title">Free Online Tools – Fast, Simple & 100% Free</h1>
                    <p className="small-title">
                        Welcome to <strong>Freelity</strong> — your one-stop destination for <strong>free online tools</strong> used by developers, students, creators, and everyday users. 
                        Access <strong>100% free tools</strong> like word counter, stopwatch, QR code generator, JSON formatter, and more. 
                        No sign-up, no limits — just powerful tools that work instantly in your browser.
                    </p>
                    <p className="text-muted" style={{ fontSize: '14px' }}>
                        Trusted by thousands of users worldwide for daily tasks and development needs.
                    </p>
                </div>
            </div>
        </section>

        <section className="sec-iii spacebox">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Calculation & Health Tools</h1>
                            <h2>Free Online Calculators – Health, Age & Personal Use Tools</h2>
                            <p>Calculate age, BMI, and more with these free and accurate online calculators. Perfect for personal use, health tracking, and everyday math. Fast, mobile-friendly, and no app or login required.</p>
                            <span>age calculator online, calculate age from dob, bmi calculator free, body mass index tool, personal calculator tools</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/age-calculator"> 
                                    <img src="/assets/img/Age-Calculator.png" className="tool-img" alt=""/>
                                    <div>
                                        <h2 className="tool-title">Age Calculator</h2>
                                        <p className="tool-dis">Free Online Age Calculator by Date of Birth</p>
                                    </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/bmi-calculator">
                                    <img src="/assets/img/BMI-Calculator.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">BMI Calculator</h2>
                                            <p className="tool-dis">Free Online BMI Calculator by Height and Weight</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/calorie-calculator">
                                    <img src="/assets/img/calories-calculator.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Calorie Calculator</h2>
                                            <p className="tool-dis">Free Online Calorie Calculator — Track Your Daily Calorie Needs</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Developer Tools</h1>
                            <h2>Free Online Developer Tools – Format, Convert & Debug Code Instantly</h2>
                            <p>Access powerful, free developer tools to format, compress, and convert your code online. Supports HTML, CSS, JavaScript, and JSON. No software, no login — perfect for programmers, coders, and tech teams.</p>
                            <span>free code formatter, json beautifier online, minify javascript, online html css tool</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/html-formatter">
                                    <img src="/assets/img/html-formatter.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">HTML Formatter</h2>
                                            <p className="tool-dis">Free Online HTML Formatter – Clean, Beautify & Indent Your Code Instantly</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/css-formatter">
                                    <img src="/assets/img/css-formatter.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">CSS Formatter</h2>
                                            <p className="tool-dis">Free Online CSS Formatter and Beautifier Tool</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/javascript-formatter">
                                    <img src="/assets/img/javascript-formatter.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Javascript Formatter</h2>
                                            <p className="tool-dis">Free Online JavaScript Formatter and Beautifier Tool</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/json-formatter">
                                    <img src="/assets/img/JSON-Formatter.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">JSON Formatter</h2>
                                            <p className="tool-dis">Free Online JSON Formatter and Beautifier Tool</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii spacebox">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Text & Writing Tools</h1>
                            <h2>Free Online Text Tools – Count Words, Convert Case & Clean Text Fast</h2>
                            <p>Simplify writing and editing with our smart text tools. Count words and characters, convert to uppercase/lowercase, remove line breaks or duplicates — all free, fast, and online. Ideal for students, writers, and bloggers.</p>
                            <span>word counter online, text case converter, remove duplicate lines online, text cleaner tool</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/word-counter">
                                    <img src="/assets/img/Word-Counter.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Word Counter</h2>
                                            <p className="tool-dis">Free Online Word Counter Tool for Text</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/text-case-converter">
                                    <img src="/assets/img/Text-Case.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Text Case Converter</h2>
                                            <p className="tool-dis">Free Online Text Case Converter Tool for Upper, Lower, Title Case</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Color & Design Tools</h1>
                            <h2>Free Online Color Picker & Converter – HEX, RGB & Image Color Tools</h2>
                            <p>Pick and convert colors online from images or codes. Use HEX to RGB converter, generate gradients, or extract colors from photos — no install, just click and get results. Perfect for designers, developers, and creatives.</p>
                            <span>color picker from image, hex to rgb converter, online color tools, extract color from image</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/image-filter-generator">
                                    <img src="/assets/img/image-filter-generator.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Image Filter Generator</h2>
                                            <p className="tool-dis">Free Online Image Filter Generator — Create & Customize CSS Filters</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/css-filter-generator">
                                    <img src="/assets/img/css-filter-generator.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Css Filter Generator</h2>
                                            <p className="tool-dis">CSS Filter Generator — Free Online Tool to Create & Customize Filters</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/gradient-generator">
                                    <img src="/assets/img/gradient-generator.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Gradient Generator</h2>
                                            <p className="tool-dis">Free Online Gradient Generator — Create Stunning Color Gradients</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/color-picker">
                                    <img src="/assets/img/Color-Picker.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Color Picker</h2>
                                            <p className="tool-dis">Free Online Color Picker Tool from Image or Code</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii spacebox">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>YouTube Tools</h1>
                            <h2>Free YouTube Tools – Download Thumbnails, Tags & Optimize Videos</h2>
                            <p>Use our free YouTube tools to download video thumbnails, generate tags, and create SEO-friendly titles and descriptions. Boost your content without software or login. Great for creators, marketers, and YouTubers.</p>
                            <span>youtube thumbnail downloader, youtube tag generator, youtube seo tools free, youtube title generator</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/youtube-thumbnail-downloader">
                                    <img src="/assets/img/Youtube-Thumbnail.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">YouTube Thumbnail Downloader</h2>
                                            <p className="tool-dis">Free Online YouTube Thumbnail Downloader Tool</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Time & Productivity Tools</h1>
                            <h2>Free Online Stopwatch & Timer – Countdown, Pomodoro & More</h2>
                            <p>Track time online with our free stopwatch, countdown timer, and Pomodoro productivity tool. Accurate to the millisecond. No sign-up. Works great on mobile, desktop, or tablet.</p>
                            <span>online stopwatch, countdown timer online, pomodoro timer free, productivity tools online</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/online-stopwatch-timer">
                                    <img src="/assets/img/Online-Stopwatch.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Online Stopwatch</h2>
                                            <p className="tool-dis">Free Online Stopwatch Tool with Lap and Timer Features</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/countdown-timer">
                                    <img src="/assets/img/Online-Timer.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Online Timer</h2>
                                            <p className="tool-dis">Free Online Timer Tool with Countdown and Alerts</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii spacebox">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>SEO & Website Tools</h1>
                            <h2>Free Online SEO Tools – Generate Meta Tags, Improve Rankings, & Analyze Content</h2>
                            <p>Boost your website’s Google rankings with free SEO tools. Create perfect meta tags, check keyword density, preview SERP snippets, and more. No limits, no sign-up — trusted by webmasters and bloggers.</p>
                            <span>meta tag generator, seo tools online free, serp preview tool, keyword density checker</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/meta-tag-generator">
                                    <img src="/assets/img/Meta-Tag.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Meta Tag Generator</h2>
                                            <p className="tool-dis">Free Meta Tag Generator for Website SEO</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>QR & Barcode Tools</h1>
                            <h2>Free Online QR Code & Barcode Generator – Easy, Custom & Downloadable</h2>
                            <p>Instantly create QR codes or barcodes for links, text, emails, or business cards. Fully free, customizable, and ready to download. Works on mobile and desktop — no app needed.</p>
                            <span>qr code generator free, barcode generator online, custom qr code, qr code for website link</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/qr-code-generator">
                                    <img src="/assets/img/QR-Code.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">QR Code Generator</h2>
                                            <p className="tool-dis">Free Online QR Code Generator for URL, Text & More</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="sec-iii spacebox">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Security & Utility Tools</h1>
                            <h2>Free Online Tools for Security, Randomization & Daily Use</h2>
                            <p>Generate strong passwords, create random values, or protect your digital identity with our security and daily-use tools. Fully free, private, and no data saved — trusted by users worldwide.</p>
                            <span>password generator online, create strong passwords, secure password maker, free random password tool</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/password-generator">
                                    <img src="/assets/img/Password.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Password Generator</h2>
                                            <p className="tool-dis">Free Online Password Generator Tool for Strong & Secure Passwords</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section className="sec-iii spacebox pt-0">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="tool-summary">
                            <h1>Content & Placeholder Tools</h1>
                            <h2>Free Online Text Placeholder & Content Generator Tools</h2>
                            <p>Need sample content? Instantly generate dummy text like Lorem Ipsum for UI designs, wireframes, and development. 100% free, customizable, and easy to use for developers and designers.</p>
                            <span>lorem ipsum generator, dummy text online, placeholder text tool, generate sample content</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="main-card-box">
                                <Link className="tools-cards" to="/lorem-ipsum-generator">
                                    <img src="/assets/img/Lorem-Ipsum.png" className="tool-img" alt=""/>
                                        <div>
                                            <h2 className="tool-title">Lorem Ipsum Generator</h2>
                                            <p className="tool-dis">Free Online Lorem Ipsum Generator Tool for Dummy Text</p>
                                        </div>
                                    <span className="tool-link">VIEW TOOLS<img src="/assets/img/next.png" className="tool-next" alt=""/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <section className="sec-iii">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="all-free-tools">
                            <div className="tools-cards">
                                <Link className="btn btn-success" to="/keyword-search-volume">Keyword Search Volume </Link>
                            </div>
                            <div className="tools-cards">
                                <Link className="btn btn-success" to="/youtube-info-extractor">YouTube Video Info Extractor </Link>
                            </div>
                            <div className="tools-cards">
                                <Link className="btn btn-success" to="/website-screenshot-generator">Website Screenshot Generator </Link>
                            </div>
                            <div className="tools-cards">
                                <Link className="btn btn-success" to="/image-to-base64">Image to Base64 Converter </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}


    </>;
};

export default Home;